import Link, { LinkProps, LinkComponentProps } from './Link';

export type { LinkProps, LinkComponentProps };
export { Link };
